/* Copyright (c) 2026 Hyegro Pty Ltd. All rights reserved. */

/**
 * Tab label for the underline tabs in tabs/index.js.
 *
 * Row/column layout for icons is left to MUI, which switches it on
 * `iconPosition`; only the sizes and the gap are set here.
 */

import colors from "assets/theme-dark/base/colors";
import borders from "assets/theme-dark/base/borders";
import typography from "assets/theme-dark/base/typography";
import pxToRem from "assets/theme-dark/functions/pxToRem";

const { brand, text, surface, outline } = colors;
const { borderRadius } = borders;
const { fontFamily } = typography;

const selectedColor = {
  color: text.focus,
  opacity: 1,
  "&.Mui-selected": {
    color: brand.primary,
  },
};

const tab = {
  defaultProps: {
    disableRipple: true,
  },

  styleOverrides: {
    root: {
      fontFamily,
      fontSize: pxToRem(14),
      fontWeight: 600,
      lineHeight: 1.25,
      textTransform: "none",
      letterSpacing: 0,
      minHeight: pxToRem(44),
      minWidth: 0,
      maxWidth: "none",
      padding: `0 ${pxToRem(16)}`,
      borderRadius: 0,
      color: text.focus,
      opacity: 1,
      gap: pxToRem(8),
      transition: "color 150ms ease, background-color 150ms ease",
      "&:hover": {
        color: text.main,
      },
      "&.Mui-selected": {
        color: brand.primary,
      },
      "&.Mui-focusVisible": {
        backgroundColor: surface.container,
        borderRadius: borderRadius.sm,
      },
      "&.Mui-disabled": {
        color: outline.variant,
        opacity: 1,
      },
      "& .MuiTab-iconWrapper, & > svg, & .material-icons, & .material-icons-round": {
        fontSize: pxToRem(18),
        width: pxToRem(18),
        height: pxToRem(18),
        margin: 0,
      },
      "& .MuiBadge-root": {
        alignItems: "center",
      },
    },
    labelIcon: {
      minHeight: pxToRem(44),
      paddingTop: 0,
      paddingBottom: 0,
    },
    wrapped: {
      fontSize: pxToRem(12),
      lineHeight: 1.2,
    },
    textColorInherit: selectedColor,
    textColorPrimary: selectedColor,
    textColorSecondary: selectedColor,
    fullWidth: {
      flex: "1 1 0",
    },
  },
};

export default tab;
